import { useState, useCallback } from 'react';
import { FetchElements } from "../../../../utils/js/request";
import { useNavigate } from "react-router-dom";
import { GET_SELECTED_SHOP_ID, REQUEST } from "../../../../utils/js/Const";
import { useLocalStorage } from "../../../../utils/js/useLocalStorage";

export const useBakeryCircleGrams = () => {
    const [circles, setCircles] = useState(null);
    const [tokenShopId] = useLocalStorage("TOKEN_SHOP_ID", null);
    const navigate = useNavigate();

    const getCircle = useCallback(async () => {
        const selectedId = GET_SELECTED_SHOP_ID();

        // Приоритет: tokenShopId > selectedId > 1
        let shopId;
        if (selectedId && selectedId !== 0 && selectedId !== '0') {
            shopId = selectedId;
        } else if (tokenShopId && tokenShopId !== 0 && tokenShopId !== '0') {
            shopId = tokenShopId;
        } else {
            shopId = 1;
        }

        const url = `${REQUEST}/api/v1/productions/circle_grams?shops_id=${shopId}`;

        return new Promise((resolve, reject) => {
            FetchElements(
                url,
                "GET",
                (responseData) => {
                    setCircles(responseData);
                    resolve(responseData);
                },
                navigate,
                2,
                () => navigate("/auth"),
                (title, message, statusCode) => {
                    const errorObj = { title, message, statusCode };
                    reject(errorObj);
                    console.error(`${title}: ${message}`);
                },
                0,
                null,
                [],
                false
            );
        });
    }, [navigate, tokenShopId]);

    return { getCircle, circles };
};